import { OreNavBarItemParent } from '@edenredespana/oreneta'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { SidebarItemModel, SidebarLink, useUI } from '@/Shared/ui/navigation'
import { navigationTranslation } from '../navigationTranslation'
import { useWebTagPermissions } from '@/User/context'
import { WebTagPermissionEnum } from '@/Shared/domain'

interface SidebarParentLinkProps {
  title: string
  icon: JSX.Element
  hover: boolean
  childs: SidebarItemModel[]
}

const SidebarParentLink = (props: SidebarParentLinkProps): JSX.Element => {
  const { hasPermission } = useWebTagPermissions();
  const [openParent, setOpenParent] = useState(false)
  const { sidebarCollapsed } = useUI()
  const { t } = useTranslation()

  const handleClickParent = (): void => setOpenParent(!openParent)

  return (
    <OreNavBarItemParent
      // active={true}
      title={t(props.title)}
      icon={props.icon}
      open={openParent}
      handleClick={handleClickParent}
      collapse={sidebarCollapsed}
      hover={props.hover}
    >
      {props.childs.map((childItem: SidebarItemModel): JSX.Element => {
        const key = childItem.link || childItem.title || `child-${JSON.stringify(childItem)}`;
        if (childItem.title === navigationTranslation.sidebar.items.contractsData ) {
          if (hasPermission(WebTagPermissionEnum.VIEW_SHOW_BILLLING_DATA)) {
            return (
              <SidebarLink
                title={t(childItem.title || '')}
                link={childItem.link}
                hover={props.hover}
                key={key}
              />
            )
          } 
          return <div key={key}></div>;      
        }
        if (childItem.title === navigationTranslation.sidebar.items.storeStickers ) {
          if (hasPermission(WebTagPermissionEnum.ACTION_REQUEST_MATERIAL)) {
            return (
              <SidebarLink
                title={t(childItem.title || '')}
                link={childItem.link}
                hover={props.hover}
                key={key}
              />
            )
          }
          return <div key={key}></div>;
        }
      return (
          <SidebarLink
            title={t(childItem.title || '')}
            link={childItem.link}
            hover={props.hover}
            key={key}
          />
        );
      })}
    </OreNavBarItemParent>
  )
}

export { SidebarParentLink }
